import React from "react";
import { Box, Hidden } from "@mui/material";
import {
  BreadCrumbsPaginas,
  MenuDashboard,
  PaginasMenuDashboard,
} from "../../../../components";
import TiposPedido from "../../../../util/typesTipoPedido";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import useSeoConfig from "../../../../hooks/useSeoConfig";
import { useEffect } from "react";
import Cripto from "../../../../components/Vitrine/Cripto"; // Você criará este componente

export default function VitrineCripto() {
  const { sendPageAtual } = useSeoConfig();

  useEffect(() => {
    sendPageAtual("Vitrine_Cripto");
  }, []);

  const breadCrumps = [
    {
      label: "Criptomoedas",
      icon: <CurrencyBitcoinIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
    },
    {
      label: "Operar Cripto",
      icon: <CurrencyBitcoinIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
    },
  ];

  return (
    <>
      <MenuDashboard pagina={PaginasMenuDashboard.OperarCripto}>
        <Hidden smUp>
          <Box sx={{ pl: 2 }}>
            <BreadCrumbsPaginas list={breadCrumps} />
          </Box>
        </Hidden>

        <Hidden smDown>
          <Box sx={{ pt: 2 }}>
            <BreadCrumbsPaginas list={breadCrumps} />
          </Box>
        </Hidden>

        <Cripto idTipoOperacao={TiposPedido.CompraCripto} />
      </MenuDashboard>
    </>
  );
}
